var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"loading":_vm.loading,"placeholder":"请选择用水区域"},on:{"focus":_vm.focus},model:{value:(_vm.inValue),callback:function ($$v) {_vm.inValue=$$v},expression:"inValue"}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }